import Vue from 'vue';
import { MutationTree } from "vuex";
import { TaxPricePeriodTranslationState } from "@/types/store/clientzone";
import { TaxPricePeriodTranslationData } from "@/types/tax_price_period_translation";

export const mutations: MutationTree<TaxPricePeriodTranslationState> = {
  SET_TAX_PRICE_PERIOD_TRANSLATION: (state, payload: Array<TaxPricePeriodTranslationData>): Array<TaxPricePeriodTranslationData> => Vue.set(state, 'taxPricePeriodTranslation', payload)
}
